import { render, staticRenderFns } from "./ClsColumn.vue?vue&type=template&id=22650c0e&"
import script from "./ClsColumn.vue?vue&type=script&lang=js&"
export * from "./ClsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports